import { isBoolean } from "@mcwd/typescript-type-guards";
import { ComputedValueGetter } from "../../../../utils/ComputedValueGetter.js";
import { DevicePrimaryHoverType, getDevicePrimaryHoverType } from "./getDevicePrimaryHoverType.js";
import { DevicePrimaryPointerType, getDevicePrimaryPointerType } from "./getDevicePrimaryPointerType.js";
import { IsMobileDeviceLegacy, isMobileDeviceLegacy } from "./isMobileDeviceUserAgent.js";
import { IsTouchScreenDevice, isTouchScreenDevice } from "./isTouchScreenDevice.js";

const navigator = globalThis.navigator as (typeof globalThis.navigator & { userAgentData?: { mobile?: boolean } });

// userAgentData is currently experimental and only available on a few chrome type browsers, but seems to be the future of checking if a device is mobile.
const navigatorUserAgentData = navigator?.userAgentData;

/** Determine if a device is a mobile device */
export function isMobileDevice (): boolean;
export function isMobileDevice ({
  userAgentData,
  ...opts
}: {
  userAgentData?: typeof navigatorUserAgentData | undefined,
  isTouchScreenFn?: () => ReturnType<typeof isTouchScreenDevice>,
  getPointerTypeFn?: () => ReturnType<typeof getDevicePrimaryPointerType>,
  getHoverTypeFn?: () => ReturnType<typeof getDevicePrimaryHoverType>,
  isMobileDeviceLegacyFn?: () => ReturnType<typeof isMobileDeviceLegacy>
}): boolean;
export function isMobileDevice({
  userAgentData = navigatorUserAgentData,
  ...opts
}: {
  userAgentData?: typeof navigatorUserAgentData | undefined,
  isTouchScreenFn?: () => ReturnType<typeof isTouchScreenDevice>,
  getPointerTypeFn?: () => ReturnType<typeof getDevicePrimaryPointerType>,
  getHoverTypeFn?: () => ReturnType<typeof getDevicePrimaryHoverType>,
  isMobileDeviceLegacyFn?: () => ReturnType<typeof isMobileDeviceLegacy>
} = {})
{
  if (userAgentData && isBoolean(userAgentData.mobile)) {
    return userAgentData.mobile === true;
  }
  const isTouchScreen = (opts.isTouchScreenFn ?? isTouchScreenDevice)();

  if (isTouchScreen !== false) {
    const pointerType = (opts.getPointerTypeFn ?? getDevicePrimaryPointerType)();
    if (pointerType === "coarse"){
      return true;
    }
    const hoverType = (opts.getHoverTypeFn ?? getDevicePrimaryHoverType)();
    if (hoverType === "none"){
      return true;
    }
  }
  return (opts.isMobileDeviceLegacyFn ?? isMobileDeviceLegacy)();
}

export const IsMobileDevice = new ComputedValueGetter({
  isLazy: true, 
  computeFn: () => {
    return isMobileDevice({
      userAgentData: navigatorUserAgentData,
      isTouchScreenFn: () => IsTouchScreenDevice.value,
      getHoverTypeFn: () => DevicePrimaryHoverType.value,
      getPointerTypeFn: () => DevicePrimaryPointerType.value,
      isMobileDeviceLegacyFn: () => IsMobileDeviceLegacy.value      
    });
  }
});
